import { Link } from 'react-router-dom'
import Layout from '../componentes/Layout.jsx'
import { ComparativoVeiculos } from '../componentes/Comparativo.jsx'
import {
  useDados, Carregando, Erro, EstadoVazio, emReais, emKm, emNumero, emData,
  NOME_PROPULSAO, MOTIVO_SEM_CONSUMO, resumoBateria,
} from '../componentes/basicos.jsx'

export default function Inicio() {
  const { dados: painel, erro, carregando } = useDados('/dashboard')
  const { dados: lembretes } = useDados('/lembretes')

  if (carregando) return <Layout titulo="Garagem"><Carregando /></Layout>
  if (erro) return <Layout titulo="Garagem"><Erro erro={erro} /></Layout>

  if (painel.veiculos.length === 0) {
    return (
      <Layout titulo="Garagem">
        <EstadoVazio titulo="Sua garagem está vazia">
          <p>Cadastre um veículo para começar a registrar abastecimentos.</p>
          <Link className="botao botao-principal" to="/garagem">Cadastrar veículo</Link>
        </EstadoVazio>
      </Layout>
    )
  }

  const pendentes = lembretes?.lembretes ?? []

  return (
    <Layout titulo="Garagem">
      {pendentes.length > 0 && <CartaoLembretes itens={pendentes} />}

      {/* No desktop os cartões convivem lado a lado; no celular, um por linha. */}
      <div className="colunas-desktop">
        {painel.veiculos.map((cartao) => (
          <CartaoVeiculo key={cartao.veiculo.id} cartao={cartao} />
        ))}

        {painel.comparativo.length > 1 && (
          <section className="cartao pilha">
            <span className="rotulo-secao">Custo total por km</span>
            <ComparativoVeiculos itens={painel.comparativo} />
          </section>
        )}

        {painel.ultimos_lancamentos?.length > 0 && (
          <UltimasRecargas itens={painel.ultimos_lancamentos} vários={painel.veiculos.length > 1} />
        )}

        {painel.referencia && (
          <section className="cartao pilha">
            <span className="rotulo-secao">Comparação de referência</span>
            <p className="dica">{painel.referencia.descricao}</p>
            <p>
              Custaria <strong>{emReais(painel.referencia.custo_energia_por_km)}/km</strong> só de
              combustível.
            </p>
          </section>
        )}
      </div>
    </Layout>
  )
}

function CartaoVeiculo({ cartao }) {
  const { veiculo, custos } = cartao

  return (
    <section className="cartao pilha">
      <div className="entre">
        <div>
          <h2>{veiculo.nome}</h2>
          <span className="dica">{NOME_PROPULSAO[veiculo.propulsao]}</span>
        </div>
        <Link className="botao botao-fantasma" to={`/veiculos/${veiculo.id}`}>Detalhes</Link>
      </div>

      {cartao.lancamentos === 0 ? (
        <p className="dica">Nenhum abastecimento registrado ainda.</p>
      ) : (
        <>
          <div>
            <div className="numero-heroi">
              {cartao.custo_total_por_km ? emReais(cartao.custo_total_por_km) : '—'}
              <small> /km</small>
            </div>
            <span className="dica">energia + manutenção + despesas</span>
          </div>

          <div className="grade-cartoes">
            <div className="metrica">
              <span className="valor">{emKm(cartao.odometro_atual)}</span>
              <span className="rotulo">odômetro</span>
            </div>
            <div className="metrica">
              <span className="valor">{emKm(cartao.km_rodados)}</span>
              <span className="rotulo">rodados</span>
            </div>
            <div className="metrica">
              <span className="valor">{emReais(custos.total)}</span>
              <span className="rotulo">custo total</span>
            </div>
            <div className="metrica">
              <span className="valor">{emData(cartao.ultimo_lancamento)}</span>
              <span className="rotulo">último lançamento</span>
            </div>
          </div>

          {cartao.energias.map((e) => (
            e.consumo_medio && (
              <p key={e.energia} className="dica">
                {e.energia === 'eletricidade' ? 'Elétrico' : 'Combustível'}:{' '}
                <strong>{emNumero(e.consumo_medio)} {e.unidade_consumo}</strong> em média,{' '}
                {emReais(e.preco_medio)} por unidade.
              </p>
            )
          ))}
        </>
      )}
    </section>
  )
}

/** Os cinco lançamentos mais recentes da garagem, com o consumo do trecho. */
function UltimasRecargas({ itens, vários }) {
  return (
    <section className="cartao pilha">
      <span className="rotulo-secao">Últimas recargas</span>
      <ul className="lista">
        {itens.map((a) => {
          const pendente = !a.custo_manual && a.custo === 0 && a.tarifa_id === null

          return (
            <li key={a.id}>
              <div className="entre">
                <div>
                  <div className="titulo-item">
                    {emNumero(a.quantidade)} {a.unidade === 'kwh' ? 'kWh' : 'L'}
                    {' · '}
                    {pendente ? 'custo pendente' : emReais(a.custo)}
                  </div>
                  <div className="detalhe">
                    {emData(a.inicio)}
                    {vários && ` · ${a.veiculo_nome}`}
                    {` · ${emKm(a.odometro)}`}
                    {a.abertura && ' · abertura'}
                  </div>
                  {resumoBateria(a) && <div className="detalhe">{resumoBateria(a)}</div>}
                  {a.obs && <div className="detalhe obs">{a.obs}</div>}
                  {a.trecho?.motivo_sem_consumo && (
                    <div className="detalhe" style={{ fontStyle: 'italic' }}>
                      {MOTIVO_SEM_CONSUMO[a.trecho.motivo_sem_consumo]}
                    </div>
                  )}
                </div>
                <div className="linha" style={{ flexWrap: 'nowrap', gap: 16 }}>
                  <div style={{ textAlign: 'right', minWidth: 76 }}>
                    <div className="titulo-item">
                      {a.trecho?.km_desde_anterior !== null && a.trecho?.km_desde_anterior !== undefined
                        ? emNumero(a.trecho.km_desde_anterior, 0)
                        : '—'}
                    </div>
                    <div className="detalhe">km rodados</div>
                  </div>
                  <div style={{ textAlign: 'right', minWidth: 86 }}>
                    <div className="titulo-item">
                      {a.trecho?.consumo ? emNumero(a.trecho.consumo) : '—'}
                    </div>
                    <div className="detalhe">
                      {a.trecho?.consumo ? a.trecho.unidade_consumo : 'sem consumo'}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
      <Link className="botao botao-fantasma" to={`/veiculos/${itens[0].veiculo_id}`}>
        Ver histórico completo
      </Link>
    </section>
  )
}

/** Ícone + texto: a urgência nunca é comunicada só pela cor. */
function CartaoLembretes({ itens }) {
  return (
    <section className="cartao pilha">
      <span className="rotulo-secao">Vencendo</span>
      <ul className="lista">
        {itens.slice(0, 5).map((item) => (
          <li key={`${item.origem}-${item.id}`}>
            <div className="entre">
              <div>
                <div className="titulo-item">
                  <span aria-hidden="true" style={{ color: item.vencido ? 'var(--critico)' : 'var(--atencao)' }}>
                    {item.vencido ? '✕ ' : '! '}
                  </span>
                  {item.titulo}
                </div>
                <div className="detalhe">
                  {item.veiculo}
                  {item.faltam_km !== null && ` · ${item.faltam_km >= 0 ? `faltam ${emKm(item.faltam_km)}` : `${emKm(-item.faltam_km)} atrasado`}`}
                  {item.faltam_dias !== null && ` · ${item.faltam_dias >= 0 ? `em ${item.faltam_dias} dia(s)` : `${-item.faltam_dias} dia(s) atrasado`}`}
                </div>
              </div>
              <span className="dica">{item.vencido ? 'vencido' : 'a vencer'}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
